module.exports = __webpack_public_path__ + "img/noicon.8dfcf64b.jpg";